module.exports = __webpack_public_path__ + "static/media/376JamesPBrawleyDrNW_2018-06-11_74.edcc402e.jpg";